
























import { io } from "socket.io-client";
import Cookies from "js-cookie";
import { API_ORIGIN } from "../app/apiConfig";
import { useNotificationStore } from "../app/notificationStore";
import messageTingSound from "../assets/message-ting.wav";
import toast from "react-hot-toast";

const IMAGE_BASE_URL = "https://uptask.visiontrek.io";

const getImageUrl = (path = "") => {
  if (!path) return "";
  if (/^https?:\/\//i.test(path)) return path;
  return `${IMAGE_BASE_URL}${path.startsWith("/") ? path : `/${path}`}`;
};

 
let socket;

export const getSocket = () => socket;
 
// export function connectSocket() {
  export function connectSocket() {
    if (socket) {
      console.log("⚠️ Socket already exists");
      return socket;
    }


 
  const messageAudio = new Audio(messageTingSound);
  messageAudio.volume = 0.55;
 
  // Unlocks audio context on first user interaction so it can autoplay later
  const unlockAudio = () => {
    messageAudio.play().then(() => {
      messageAudio.pause();
      messageAudio.currentTime = 0;
      console.log("🔊 Audio Unlocked for this session");
    }).catch(() => {});
    document.removeEventListener('click', unlockAudio);
    document.removeEventListener('keydown', unlockAudio);
  };
  document.addEventListener('click', unlockAudio);
  document.addEventListener('keydown', unlockAudio);
 
 
  const token = Cookies.get("token") || localStorage.getItem("token");
  if (!token) return;
 
    socket = io(process.env.REACT_APP_SOCKET_ORIGIN || API_ORIGIN || undefined, {
    auth: { token },
  });
 
  // socket.on("connect", () => {
  //   console.log("🟢 Socket connected:", socket.id);
  // });
 
 
socket.on("connect", () => {
  console.log("🟢 Socket connected:", socket.id);
 
  const user = JSON.parse(localStorage.getItem("user"));
 
  if (user?.id) {
    socket.emit("join", `user_${user.id}`); // ✅ FIXED
  }
});
 
 
 
 
  socket.on("notification", (data) => {
    if (data?.type === "NOTIFICATIONS_CLEARED" || data?.cleared) {
      useNotificationStore.getState().clearAll();
      return;
    }

    console.log("🔔 Notification (raw):", data);
 
      // 🔊 PLAY SOUND
  messageAudio.currentTime = 0;   // restart sound if already playing
  messageAudio.play().catch((err) => {
    console.log("Autoplay blocked:", err);
  });
 
 
    // 🧠 Extract employee info from message
    // eslint-disable-next-line no-unused-vars
    let employeeName = "Employee";
    let employeeId = null;
 
    if (typeof data.message === "string") {
      const match = data.message.match(/Employee\s+#(\d+)/);
      if (match) {
        employeeId = match[1];
        employeeName = `Employee ${employeeId}`;
      }
    }
 
 



    const formattedNotification = {
      id: `${data.type}_${Date.now()}`,
      type: (data.type || "general").toLowerCase(),
    
      message:
        data.type === "leave"
          ? `${data.userdata?.first_name || ""} ${data.userdata?.last_name || ""} applied for leave`
          : data.message || "New notification",
    
      leaveType: data.leave_type || "",
    
      // ✅ KEEP OLD
      userdata: data.userdata || null,
    
      // ✅ ADD THIS (VERY IMPORTANT)
      sender_profile_pic: data.sender_profile_pic || null,
    
      redirectTo:
        data.type === "leave"
          ? "/leaves/pending"
          : data.type === "TASK_ASSIGNED" || data.type === "task_assigned"
          ? "/"
          : data.type === "EMPLOYEE OF THE MONTH" || data.type === "EMPLOYEE_OF_THE_MONTH"
          ? "/"
          : "/",
    
      createdAt: Date.now(),
    };

    // Special celebratory toast for Employee of the Month
    if (data.type === "EMPLOYEE OF THE MONTH" || data.type === "EMPLOYEE_OF_THE_MONTH") {
      toast.success(
        (t) => (
          <div className="flex items-center gap-3">
            <div className="w-12 h-12 rounded-full overflow-hidden border-2 border-yellow-400 shadow-lg">
              {data.userdata?.winnerPic ? (
                <img 
                  src={`${IMAGE_BASE_URL}${data.userdata.winnerPic}`} 
                  alt="Winner" 
                  className="w-full h-full object-cover"
                />
              ) : (
                <div className="w-full h-full bg-yellow-400 flex items-center justify-center text-white font-bold">
                  🌟
                </div>
              )}
            </div>
            <div>
              <p className="font-bold text-gray-900 dark:text-white">🌟 {data.title}</p>
              <p className="text-sm text-gray-600 dark:text-gray-300">{data.message}</p>
            </div>
          </div>
        ),
        { duration: 6000, position: "top-center" }
      );
    }
 
    useNotificationStore.getState().addNotification(formattedNotification);
  });

  socket.off("notifications_cleared");
  socket.on("notifications_cleared", () => {
    useNotificationStore.getState().clearAll();
  });

  socket.off("notification_cleared");
  socket.on("notification_cleared", ({ id } = {}) => {
    if (id) {
      useNotificationStore.getState().removeNotification(id);
    }
  });
 
  socket.off("receive_message"); // ✅ ADD THIS


  socket.on("receive_message", (data) => {
    const user = JSON.parse(localStorage.getItem("user") || "{}");
  
    if (data.senderId === user.id) return;
  
    const { activeChatId, activeGroupId } = useNotificationStore.getState();
  
    const isRoomOpen = data.groupId
      ? activeGroupId === data.groupId
      : activeChatId === data.senderId;
  
    if (isRoomOpen) return;
  
    // 🔊 sound
    messageAudio.currentTime = 0;
    messageAudio.play().catch(() => {});
  
    useNotificationStore.getState().incrementChatUnread();
  
    const isTabActive = document.visibilityState === "visible";
  
    const senderName =
      data.senderName ||
      `${data.sender_first_name || ""} ${data.sender_last_name || ""}`.trim() ||
      "New Message";
      // console.log('message',message)

    const chatMessage =
      data.type === "image"
        ? "sent an image"
        : data.type === "file"
        ? "sent an attachment"
        : data.message || "sent a message";

    useNotificationStore.getState().addNotification({
      id: `chat_${data.id || data.messageId || `${data.senderId}_${data.groupId || data.receiverId || "direct"}_${data.createdAt || Date.now()}`}`,
      type: "chat",
      title: data.groupId ? "Group message" : "New chat message",
      message: data.groupId
        ? `${senderName} in ${data.groupName || "group"}: ${chatMessage}`
        : `${senderName}: ${chatMessage}`,
      sender_profile_pic: data.senderProfilePic || data.sender_profile_pic || null,
      senderId: data.senderId,
      groupId: data.groupId || null,
      redirectTo: "/",
      created_at: data.createdAt || new Date().toISOString(),
      metadata: {
        userId: data.senderId,
        groupId: data.groupId || null,
      },
    });
  
    const senderProfilePic =
      getImageUrl(data.senderProfilePic || data.sender_profile_pic) ||
      `${IMAGE_BASE_URL}/default-avatar.png`;
  
    if (isTabActive) {
      window.dispatchEvent(new CustomEvent("uptask:quick-reply-message", {
        detail: {
          ...data,
          chatMessage,
          senderName,
          senderProfilePic,
        },
      }));
    } else {
      if (Notification.permission === "granted") {
        const notification = new Notification(senderName, {
          body: data.message,
          icon: senderProfilePic,
          silent: true, // Prevent browser from playing its own sound
        });
  
        notification.onclick = () => {
          window.focus();
        
          // store data temporarily
          localStorage.setItem(
            "openChatFromNotification",
            JSON.stringify({
              userId: (data.groupId || data.group_id) ? null : (data.senderId || data.sender_id),
              groupId: data.groupId || data.group_id || null,
              groupName: data.groupName || data.group_name || "",
              senderName,
              profilePic: data.senderProfilePic || data.sender_profile_pic || "",
            })
          );
        
    window.dispatchEvent(new CustomEvent("uptask:open-chat-from-notification", {
      detail: {
        userId: (data.groupId || data.group_id) ? null : (data.senderId || data.sender_id),
        groupId: data.groupId || data.group_id || null,
        groupName: data.groupName || data.group_name || "",
        senderName,
        profilePic: data.senderProfilePic || data.sender_profile_pic || "",
      },
    }));
        };
      }
    }
  });

  // Listener for dynamic group joining
  socket.on("added_to_group", (data) => {
    socket.emit("join_group", { groupId: data.groupId });
  });
 
socket.on("disconnect", () => {
    console.log("🔴 Socket disconnected");
  });
}
 
export function disconnectSocket() {
  if (socket) {
    socket.disconnect();
    socket = null;
  }
}
